import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('a-col', {
    staticClass: "pt-30",
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [_vm._t("tip"), _c('h4', {
    staticClass: "flex-box"
  }, [_c('span', {
    staticClass: "flex-item"
  }, [_vm._v(_vm._s(_vm.t('客户代码')) + _vm._s(_vm.tc('：')) + " " + _vm._s(_vm.$store.state.user.customerInfo.customer_code))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "data-permission": "welcome_add_subject",
      "id": "welcome_add_subject",
      "fbu-analyse-name": $t("\u6DFB\u52A0\u4E3B\u4F53")
    },
    on: {
      "click": _vm.handleAddFirm
    }
  }, [_vm._v(_vm._s(_vm.t('添加主体')))])], 1), _c('a-skeleton', {
    attrs: {
      "loading": _vm.loading,
      "active": ""
    }
  }, [_c('my-table', {
    attrs: {
      "columns": _vm.columns,
      "data-source": _vm.dataList,
      "bordered": ""
    },
    scopedSlots: _vm._u([{
      key: "sign_body_status_text",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('div', {
          class: {
            'other-tag': _vm.data.status === _vm.$enum.mine.CustomerStartupStatusEnum.AUDIT_PENDING ? record.sign_body_status !== _vm.$enum.mine.SignBodyStatusEnum.AUDITING : record.sign_body_status === _vm.$enum.mine.SignBodyStatusEnum.AUDIT_NOT_PASS
          }
        }, [_c('span', [_vm._v(_vm._s(record.sign_body_status_text))]), record.rejected_remark && record.sign_body_status === _vm.$enum.mine.SignBodyStatusEnum.AUDIT_NOT_PASS ? _c('a-popover', {
          attrs: {
            "content": record.rejected_remark
          }
        }, [_c('a-icon', {
          staticClass: "ml-5",
          attrs: {
            "type": "exclamation-circle"
          }
        })], 1) : _vm._e()], 1)]);
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {
          staticStyle: {
            "width": "120px"
          }
        }, [record.register_area_code === _vm.$enum.mine.RegisterAreaCodeEnum.CN && (record.sign_body_status === _vm.$enum.mine.SignBodyStatusEnum.DRAFT || record.sign_body_status === _vm.$enum.mine.SignBodyStatusEnum.AUDIT_NOT_PASS) ? _c('a', {
          staticClass: "mr-5",
          attrs: {
            "href": "javascript:",
            "fbu-analyse-name": $t("\u8BA4\u8BC1")
          },
          on: {
            "click": function ($event) {
              return _vm.handleApprove(record.account_code);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('认证')))]) : record.register_area_code !== _vm.$enum.mine.RegisterAreaCodeEnum.CN && (record.sign_body_status === _vm.$enum.mine.SignBodyStatusEnum.DRAFT || record.sign_body_status === _vm.$enum.mine.SignBodyStatusEnum.AUDIT_NOT_PASS) ? _c('a', {
          staticClass: "mr-5",
          attrs: {
            "href": "javascript:",
            "fbu-analyse-name": $t("\u63D0\u4EA4\u5BA1\u6838")
          },
          on: {
            "click": function ($event) {
              return _vm.handleSubmit(record.account_code);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('提交审核')))]) : _vm._e(), record.sign_body_status === _vm.$enum.mine.SignBodyStatusEnum.DRAFT || record.sign_body_status === _vm.$enum.mine.SignBodyStatusEnum.AUDIT_NOT_PASS ? _c('a', {
          staticClass: "mr-5",
          attrs: {
            "href": "javascript:",
            "fbu-analyse-name": $t("\u7F16\u8F91")
          },
          on: {
            "click": function ($event) {
              return _vm.handleEdit(record.account_code);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('编辑')))]) : _vm._e(), _c('a', {
          attrs: {
            "href": "javascript:",
            "fbu-analyse-name": $t("\u590D\u5236")
          },
          on: {
            "click": function ($event) {
              return _vm.handleCopy(record.account_code);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('复制')))])]);
      }
    }])
  })], 1)], 2);
};

var staticRenderFns = [];
export { render, staticRenderFns };